var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { selectContractCooldownTime } from "../../selectors/selectContractInfo";
import { utilTime } from "../../utils/utilTime";
import { TypeActionContractInfo } from "./actionContractInfo";
var initial = {
    // Initialize cooldown time from localStorage
    contract: [],
    cooldownTime: selectContractCooldownTime().cooldownTime || 0,
};
export var reducerContractInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionContractInfo.Received && action.contractInfo != undefined) {
        return __assign({}, state, action.contractInfo, { contract: action.contractInfo.contract.map(function (contract) { return (__assign({}, contract, { remainingTime: utilTime.remainingTimeToTimestamp(contract.remainingTime) })); }) });
    }
    else if (action.type === TypeActionContractInfo.StartCooldown &&
        action.cooldownTime != undefined) {
        var cooldownTimeStamp = utilTime.remainingTimeToTimestamp(action.cooldownTime);
        var cooldownTime = {
            cooldownTime: cooldownTimeStamp,
        };
        return __assign({}, state, cooldownTime);
    }
    else if (action.type === TypeActionContractInfo.FinishCooldown) {
        var cooldownTime = {
            cooldownTime: 0,
        };
        return __assign({}, state, cooldownTime);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/reducerContractInfo.ts
// module id = 2547
// module chunks = 3